export default "__VITE_ASSET__7273cf85__"